/** Dialog width for the organ recovery confirmation modal. */
export const ORGAN_RECOVERY_CONFIRMATION_MODAL_WIDTH = '480px';

/** Fixed question rendered by the modal - never derived from stored data. */
export const ORGAN_RECOVERY_CONFIRMATION_QUESTION = 'Was the organ recovered and transported?';

/**
 * The exact rejection text the V1 leg route and the V2 segment route both return when a leg/segment
 * transition would complete an eligible Team service request whose answer is still missing. Kept as
 * a single constant on both sides (backend: `OrganRecoveryCompletionBoundary.ConfirmationRequiredMessage`)
 * so the two cannot drift apart.
 *
 * A leg-level Job Done cannot be predicted client side - the leg lists the driver dashboard and the
 * leg details panel hold carry neither the service type/sub type nor the sibling legs' cancellation
 * flags, so the SR completion boundary is only known to the server. These flows therefore attempt
 * the transition and open the modal when, and only when, the server says the boundary was reached.
 */
export const ORGAN_RECOVERY_CONFIRMATION_REQUIRED_MESSAGE =
  'The organ recovery confirmation must be answered before this service request can be completed.';

/** V2 error code for the same rejection, surfaced by the V2 validation error envelope. */
export const ORGAN_RECOVERY_CONFIRMATION_REQUIRED_CODE = 'ORGAN_RECOVERY_CONFIRMATION_REQUIRED';

/** Shown when the server sends neither a V2 `errorMessage` nor a legacy `errors[0]`. */
export const ORGAN_RECOVERY_CONFIRMATION_GENERIC_ERROR = 'Failed to save the organ recovery confirmation. Please try again';
